module.exports = __webpack_public_path__ + "static/media/dealer-pin.c17b7752.png";